<template>
  <div>
    <h4>Глагол Verb</h4>

    <h5 class="indigo-text text-darken-1">Времена</h5>

    <div class="row">
      <div class="col s12 m8 l6">
        <table>
          <tbody>
            <tr>
              <td>Plusquamperfekt</td>
              <td>er hatte gelesen</td>
              <td>прошлое</td>
            </tr>

            <tr>
              <td>Präteritum</td>
              <td>er las</td>
              <td>прошлое</td>
            </tr>

            <tr>
              <td>Perfekt</td>
              <td>er hat gelesen</td>
              <td>прошлое</td>
            </tr>

            <tr>
              <td>Präsens</td>
              <td>er liest</td>
              <td>настоящее</td>
            </tr>

            <tr>
              <td>Futur II</td>
              <td>er wird gelesen haben</td>
              <td>будущее</td>
            </tr>

            <tr>
              <td>Futur I</td>
              <td>er wird lesen</td>
              <td>будущее</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 class="fontbold">Präsens</h6>
    <p class="indigo-text text-darken-1 fontbold">корень глагола + личное окончание</p>
    <blockquote>ich male, du malst, er malt, wir malen, ihr malt, sie malen</blockquote>

    <p>
      1. то, что сейчас существует или сейчас происходит. Ich gehe in Marbach zur Schule.
      <br />2. то, что началось ранее, но продолжается сейчас. Seit neun Monaten lebe ich schon hier.
      <br />3. то, что произойдёт в будущем. Morgen mache ich einen Klassenausflug.
      <br />4. то, что всегда действительно. Ich heiße Carolin und komme aus Brasilien.
    </p>

    <p>
      Особенности произнесения.
      <br />1. если корень глагола заканчивается на -d/-t, -m/-n, то + e.
      <br />arbeiten: du arbeitest, er arbeitet, ihr arbeitet
      <br />rechnen: du rechnest, er rechnet, ihr rechnet
      <br />2. если корень глагола заканчивается на -ß, -s, -ss, -z, -tz, то -s выпадает
      <br />grüßen: du grüßt
      <br />3. если глагола заканчивается на -eln, то -e выпадает
      <br />lächeln: ich lächle
    </p>

    <p>
      Изменение корневой гласной в некоторых неправильных глаголах во 2. и 3. лице ед.числа.
      <br />a - ä. fallen: du fällst, er fällt
      <br />au - äu. laufen: du läufst, er läuft
      <br />e - i. helfen: du hilfst, er hilft
      <br />e - ie. lesen: du liest, er liest
      <br />o - ö. stoßen: du stößt, er stößt
      <br />Внимание!!! nehmen: du nimmst, er nimmt
    </p>

    <h6 class="fontbold">Perfekt</h6>
    <p class="indigo-text text-darken-1 fontbold">Präsens от haben или sein + Partizip II</p>
    <blockquote>
      ich habe gekocht, du hast gekocht, er hat gekocht
      <br />ich bin gelaufen, du bist gelaufen, er ist gelaufen
    </blockquote>

    <p>Perfekt описывает что-то прошедшее, что имеет отношение к настоящему.</p>

    <div class="row">
      <div class="col s12 m10 l8">
        <table>
          <tbody>
            <tr>
              <td>haben (в основном)</td>
              <td>sein</td>
            </tr>

            <tr>
              <td>
                возвратные глаголы (reflexiven Verben),
                глаголы с объектом в Akkusativ, модальные глаголы (Modalverben)
              </td>
              <td>
                все остальные глаголы, глаголы показывающие изменения места, позиции или состояния:
                gehen, fahren, einschlafen, aufwachen, sein, werden, bleiben, passieren, geschehen.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 class="fontbold">Präteritum</h6>

    <h6 class="fontbold">Правильные глаголы Regelmäßige Verben</h6>

    <p class="indigo-text text-darken-1 fontbold">корень инфинитива + -t- + личное окончание</p>

    <div class="row">
      <div class="col s12 m6 l4">
        <table>
          <tbody>
            <tr>
              <td>ich wohnte</td>
              <td>wir wohnten</td>
            </tr>

            <tr>
              <td>du wohntest</td>
              <td>ihr wohntet</td>
            </tr>

            <tr>
              <td>er wohnte</td>
              <td>sie wohnten</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <h6 class="fontbold">Неправильные глаголы Unregelmäßige Verben</h6>

    <p class="indigo-text text-darken-1 fontbold">
      корень Präteritum + личное окончание
      <br />1. и 3. лицо ед.ч. всегда без окончания.
      <br />корневая гласная почти всегда меняется.
    </p>

    <div class="row">
      <div class="col s12 m6 l4">
        <table>
          <tbody>
            <tr>
              <td>gehen</td>
              <td>bringen</td>
            </tr>

            <tr>
              <td>ich ging</td>
              <td>ich brachte</td>
            </tr>

            <tr>
              <td>du gingst</td>
              <td>du brachtest</td>
            </tr>
            <tr>
              <td>er ging</td>
              <td>er brachte</td>
            </tr>
            <tr>
              <td>wir gingen</td>
              <td>wir brachten</td>
            </tr>
            <tr>
              <td>ihr gingt</td>
              <td>ihr brachtet</td>
            </tr>
            <tr>
              <td>sie gingen</td>
              <td>sie brachten</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <p>
      Präteritum описывает уже законченные действия в прошлом. Он применяется прежде всего в письменной форме.
      В устной речи применяется, за иключением вспомогательных и модальных глаголов, скорее чем Perfekt.
    </p>

    <h6 class="fontbold">Plusquamperfekt</h6>

    <p class="indigo-text text-darken-1 fontbold">Präteritum от haben или sein + Partizip II</p>
    <blockquote>
      ich hatte gekocht, du hattest gekocht, er hatte gekocht
      <br />ich war gelaufen, du warst gelaufen
    </blockquote>
    <p>Plusquamperfekt описывает что-то, что случилось ещё перед Präteritum.</p>
    <blockquote>Nachdem die Mutter alles aufgeräumt hatte, ging sie müde zu Bett. Sie hatte alle Hausarbeiten alleine gemacht.</blockquote>

    <h6 class="fontbold">Futur I</h6>

    <p class="indigo-text text-darken-1 fontbold">Präsens от werden + Infinitiv</p>
    <blockquote>ich werde fahren, du wirst fahren, er wird fahren, wir werden fahren, ihr werdet fahren, sie werden fahren</blockquote>
    <p>
      1. то, что случится в будущем. Nächstes Jahr werde ich eine Weltreise machen.
      <br />2. то, что ожидается или предполагается. Die kommende Woche wird sicher Klarheit bringen. Er wird wohl kündigen.
    </p>
    <p>Однако в основном используется Präsens с ясным указанием времени, что речь идёт о просходящем в будущем.</p>
    <blockquote>
      Morgen beginnen die Ferien.
      <br />Nächstes Jahr fahren wir wieder nach Spanien.
      <br />Er hat kommenden Monat Prüfung.
    </blockquote>

    <h6 class="fontbold">Futur II</h6>

    <p class="indigo-text text-darken-1 fontbold">Präsens от werden + Partizip II + haben или sein</p>
    <blockquote>
      ich werde gegessen haben, du wirst gegessen haben, er wird gegessen haben
      <br />ich werde gegangen sein, du wirst gegangen sein
    </blockquote>
    <p>
      При помощи Futur II можно сказать, что в будущем что-то уже совершится, закончится. Futur II используется редко.
      <br />Bald wirst du die Prüfung bestanden haben. (Прогноз)
      <br />Er wird noch zu seiner Freundin gegangen sein. (Предположение)
    </p>
  </div>
</template>


<style scoped>
.fontbold {
  font-weight: bold;
}
td {
  padding: 2px 2px;
}
</style>


<script>
export default {
  name: "grammatik_verbzeiten",
  data: () => ({}),
  computed: {}
};
</script>
